export const bg = {
    nav: {
        apartments: 'Апартаменти',
        location: 'Локация',
        payment: 'Плащане',
        materials: 'Материали',
        about: 'За комплекса',
        contacts: 'Контакти'
    },
    contactForm: {
        title: 'Свържете се с нас',
        nameLabel: 'Име',
        emailLabel: 'Имейл',
        messageLabel: 'Съобщение',
        submitBtn: 'Изпрати'
    },
    footer: {
        phone: 'Телефон',
        email: 'Имейл',
        address: 'Адрес',
        addressLinkText: 'гр. Варна, кв. Бриз',
        copyright: 'Jura RESIDENCE. All rights reserved.'
    },
    home: {
        heroSliderText: 'Където морето среща природата - в топ локацията на квартал Бриз',
        heroSliderBtn: 'Изберете вход',
        introLeft: 'Стилни и просторни домове за щастлив семеен живот',
        introRight: 'Луксозният жилищен комплекс „ЮРА“ е ситуиран на отлична локация, която осигурява бърз достъп до центъра на морската столица и до курортните комплекси „Св.Св.Константин и Елена” и „Златни пясъци”. Непосредствената близост до спирки на градския транспорт позволява удобен достъп до всички направления.',
        introBtn: 'Виж повече за комплекса',
        chooseApartments: 'Избор на апартаменти',
        viewParking: 'Виж гаражите',
        box1Title: 'Топ локация',
        box1Text: 'Квартал Бриз е един от най-престижните райони за живеене на град Варна',
        box2Title: 'Отлична комуникация',
        box2Text: 'Непосредствена близост до бул. "Васил Левски" и бул. "Княз Борис I".',
        box3Title: 'Луксозна визия',
        box3Text: 'Луксозна фасада с естествени материали и отлично качество.',
        box4Title: 'Близо до природата',
        box4Text: 'Апартаменти, граничещи с Морската градина и Парк-паметник на българо-съветската дружба.',
        box5Title: 'Стандарт за качество',
        box5Text: 'Строители с богат опит и най високо качество на вложените материали.',
        box6Title: 'Удобства за живущите',
        box6Text: 'Подземни гаражи, търговски и офис площи, асансьори.',
        quickLink1Title: 'Фасада/Материали',
        quickLink1Text: 'Нискоетажна сграда, която е в хармония със заобикалящата я среда, съобразена с всички изисквания за енергийна ефективност клас А.',
        quickLink2Title: 'Допълнителни удобства',
        quickLink2Text: 'Апартаментите са с подготовка за климатизация и подготовка за газоснабдяване. Решен e проблемът с паркирането.',
        quickLink3Title: 'Уютни апартаменти',
        quickLink3Text: 'Малко на брой апартаменти във вход – малко съседи за добър жилищен комфорт. Всеки един от тях е с отлично изложение и отлична звукоизолация.',
        whyJura: 'Защо да изберем жилищен комплекс „Юра“?',
        availableApartments: 'Свободни апартаменти',
        whyJura1Title: 'Висок стандарт, контрол и гаранции на завършеност',
        whyJura1Text: 'Цялостната визия и добрият облик на сградата е с приоритет за нас. Имотът е проектиран според последните тенденции в архитектурата и съвременните конструктивни изисквания. Доброто изпълнение на общите части е предпоставка за дълготрайна употреба и качество.',
        whyJura2Title: 'Престижна локация и комуникативност',
        whyJura2Text: 'Изключително комуникативно място - до бул.”Васил Левски”  и бул.”Княз Борис I”, с достъп до градския транспорт във всички направления. В близост се намират елитни учебни заведения. Сградата граничи с два парка. Непосредствено до “Юра” се намират Стадион „Варна“, Делфинариума, тенис кортове и басейни, детски градини и разнообразни заведения за хранене и забавление.',
        whyJura3Title: 'Разнообразие от удобни апартаменти',
        whyJura3Text: 'Жилищен комплекс „ЮРА се състои от четири входа и включва 52 апартамента от 74 до 300 кв.м.– двустайни , тристайни , четиристайни и многостайни с уникални характеристики. Малкото на брой жилища, с големи помещения и всички удобства наподобяват еднофамилна къща.',
    },
    apartments: {
        position: 'Изложение',
        east: 'Изток',
        west: 'Запад',
        north: 'Север',
        south: 'Юг',
        northEast: 'Североизток',
        northWest: 'Северозапад',
        southEast: 'Югоизток',
        southWest: 'Югозапад',
        available: 'Свободен',
        reserved: 'Резервиран',
        sold: 'Продаден',
        goToApartments: 'Към апартаменти',
        chooseEntrance: 'Изберете вход',
        chooseFloor: 'Изберете етаж',
        inputNumber: 'Въведете номер',
        chooseType: 'Изберете вид',
        inputNetArea: 'Въведете чиста площ',
        inputGrossArea: 'Въведете обща площ',
        inputPosition: 'Въведете изложение',
        chooseStatus: 'Изберете статус',
        twoRoom: 'Двустаен',
        threeRoom: 'Тристаен',
        fourRoom: 'Четиристаен',
        manyRoom: 'Многостаен',
        priceNegotiable: 'По договаряне'
    },
    parking: {
        available: 'Свободно',
        reserved: 'Резервирано',
        sold: 'Продадено'
    },
    page404: {
        title: 'Грешка 404',
        text: 'Страницата, която търсите, не може да бъде намерена. Моля изберете друга от менюто или се върнете в началото.'
    },
    messages: {
        messageSentSuccessfully: 'Вашето съобщение беше изпратено успешно.',
        errorSendingMessage: 'Възникна грешка с изпращането на съобщението. Моля опитайте пак по-късно.',
        requiredFields: 'Всички полета са задължителни.',
        invalidUrl: 'Невалиден URL'
    },
    general: {
        siteName: 'Жилищен комплекс "Юра"',
        previousBtn: 'Предишен',
        nextBtn: 'Следващ',
        price: 'Цена',
        floor: 'Етаж',
        floor_short: 'ет.',
        entrance: 'Вход',
        entrance_short: 'вх.',
        number: 'Номер',
        type: 'Вид',
        status: 'Статус',
        area: 'Площ',
        netArea: 'Чиста площ',
        grossArea: 'Обща площ',
        apartment: 'апартамент',
        maisonette: 'мезонет',
        apartment_plural: 'Апартаменти',
        parkingLots: 'Гаражи',
        viewMore: 'Виж повече',
        homeBtn: 'Върни ме в началото',
        home: 'Начало',
        basement: 'Сутерен',
        print: 'Принтирай страницата с апартамента'
    }
}



// WEBPACK FOOTER //
// ./src/utils/translations/bg.js